// extracted by mini-css-extract-plugin
export default {"glow":"TitleGlow_glow__-Zx6d","text":"TitleGlow_text__U5vy-"};